import { Component } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { IndividualService } from 'src/app/services/individual/individual.service';
import { DeleteItemComponent } from '../delete-item/delete-item.component';
import { MatDialog } from '@angular/material/dialog';
import {
  trigger,
  transition,
  style,
  animate,
} from '@angular/animations';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [
    trigger('fadeOut', [
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(20px)' }))
      ])
    ])
  ]
})
export class NotificationComponent {
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public count!: any;
  public notificationArr: any[] = [];
  constructor(private indivisualService: IndividualService, private commonService: CommonService, private appService: AppService, private dialog: MatDialog,) { }
  ngOnInit(): void {
    this.commonService.setTitle("Notification");
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.getNotification()
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.getNotification()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.getNotification()

  }

  getNotification() {

    let data = {
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      "type": "1",
    }

    this.indivisualService.getNotification(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.notificationArr = success.data;
          this.count = success.count
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }

  hideNotification(id: any) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_notification", id: id }
    }));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        const index = this.notificationArr.findIndex(item => item.id === id);
        if (index !== -1) {
          this.notificationArr.splice(index, 1);
        }
      }
    });
  }
}
